import type { RouteObject } from 'react-router-dom'

const payrollRoute: RouteObject = {
  path: 'payroll',
  children: [
    {
      path: 'tax-settings',
      children: [{ path: '', lazy: () => import('@/pages/payroll/tax-settings/page') }],
    },
    {
      path: 'proccess',
      children: [{ path: '', lazy: () => import('@/pages/payroll/payroll-proccess/page') }],
    },
    { path: 'bpjs-component', lazy: () => import('@/pages/payroll/(components)/bpjs-component/page') },
    { path: 'payload-component-policy', lazy: () => import('@/pages/payroll/payroll-component-policy/page') },
    {
      path: 'benefit-components',
      children: [
        { path: '', lazy: () => import('@/pages/payroll/(components)/benefit-components/page') },
        { path: ':componentId/employees', lazy: () => import('@/pages/payroll/(components)/benefit-components/detail-employees/page') },
      ],
    },
    {
      path: 'deduction-components',
      children: [
        { path: '', lazy: () => import('@/pages/payroll/(components)/deduction-components/page') },
        { path: ':componentId/employees', lazy: () => import('@/pages/payroll/(components)/deduction-components/detail-employees/page') },
      ],
    },
    {
      path: 'run-payroll-request',
      children: [
        { path: '', lazy: () => import('@/pages/payroll/run-payroll-request/index/page') },
        { path: ':payrollRequestId', lazy: () => import('@/pages/payroll/run-payroll-request/detail/page') },
      ],
    },
    { path: 'generated-payroll-request', lazy: () => import('@/pages/payroll/generated-payroll-request/page') },
    {
      path: 'payroll-request',
      children: [
        { path: '', lazy: () => import('@/pages/payroll/payroll-request/index/page') },
        { path: ':payrollRequestId', lazy: () => import('@/pages/payroll/payroll-request/detail/page') },
      ],
    },
    {
      path: 'spt-1721-induk',
      lazy: () => import('@/pages/payroll/spt-1721/induk/page'),
    },
    {
      path: 'spt-1721-i',
      lazy: () => import('@/pages/payroll/spt-1721/I/page'),
    },
    {
      path: 'spt-1721-a1',
      lazy: () => import('@/pages/payroll/spt-1721/a1/page'),
    },
    {
      path: 'payroll-matrix',
      children: [
        { path: '', lazy: () => import('@/pages/payroll/matrix/index/page') },
        // { path: ':payrollMatrixId', lazy: () => import('@/pages/payroll/matrix/detail/page') },
      ],
    },
    {
      path: 'bpjs-tk-report',
      lazy: () => import('@/pages/payroll/bpjs-tk-report/page'),
    },
    {
      path: 'bpjs-ks-report',
      lazy: () => import('@/pages/payroll/bpjs-ks-report/page'),
    },
  ],
}

export default payrollRoute
